class ProductForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.addToCartButton = this.querySelector('.add-to-cart-btn');
        this.current_variant_id = this.getAttribute('variant-id');
        this.productHandle = this.getAttribute('product-handle');

        this.variants = JSON.parse(this.querySelector('#product-variants-json').innerText);
        this.currentVariant = this.variants.find(variant => variant.id == this.current_variant_id);


        this.soldOutBadge = document.querySelector('.sold_out_badge_pdp');
    }

    getVariantInventory(variantId) {
        const variant = this.variants.find(v => v.id == variantId);
        return variant ? variant.inventory_quantity : 0;
    }

    // ✅ Currency Formatting Function (Custom Symbols)
    formatMoney(cents) {
        const activeCurrency = window?.Shopify?.currency?.active || '{{ shop.currency }}';
        const v = Number(cents) / 100;
        if (isNaN(v)) return '0.00';

        switch (activeCurrency) {
            case "INR":
                return 'Rs ' + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "USD":
                return '$' + v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "DKK":
                return v.toLocaleString("da-DK", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " kr";
            case "AED":
                return 'Dhs ' + v.toLocaleString("en-AE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "EUR":
                return '€' + v.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "GBP":
                return '£' + v.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "CAD":
                return 'CA$' + v.toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "AUD":
                return 'A$' + v.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            default:
                try {
                    return new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: activeCurrency
                    }).format(v);
                } catch (e) {
                    return v.toFixed(2) + ' ' + activeCurrency;
                }
        }
    }

    updatePrice(variantId) {
        const priceEl = document.getElementById('current-variant-price');
        const compareEl = document.getElementById('current-variant-compare-price');
        const badgeEl = document.querySelector('.main-product-badge');

        if (!priceEl) return;

        const variant = this.variants.find(v => v.id == variantId);
        if (!variant) return;

        const priceCents = variant.price_cents || 0;
        const compareCents = variant.compare_at_price_cents || 0;

        // ✅ Update main price
        priceEl.innerText = this.formatMoney(priceCents);

        // ✅ Update compare price with strikethrough
        if (compareEl) {
            if (compareCents > priceCents) {
                compareEl.innerHTML = `<s>${this.formatMoney(compareCents)}</s>`;
                compareEl.style.display = 'inline';
            } else {
                compareEl.style.display = 'none';
            }
        }

        // ✅ Update discount badge
        if (badgeEl) {
            if (compareCents > priceCents) {
                const discount = Math.round(((compareCents - priceCents) / compareCents) * 100);
                badgeEl.innerText = `Spar ${discount}%`;
                badgeEl.style.display = 'inline';
            } else {
                badgeEl.style.display = 'none';
            }
        }
    }

    updateSoldOutBadge() {
        if (!this.soldOutBadge || !this.currentVariant) return;

        if (!this.currentVariant.available) {
            this.soldOutBadge.style.display = 'inline-flex';
        } else {
            this.soldOutBadge.style.display = 'none';
        }
    }


    connectedCallback() {
        this.addEventListener('submit', this.handleFormSubmit.bind(this));
        this.addEventListener('change', this.updateVariant.bind(this));

        if (this.querySelector('#main-variant-select')) this.querySelector('#main-variant-select').style.display = 'none';
        if (this.querySelector('.product-variant-options')) this.querySelector('.product-variant-options').style.display = 'block';

        window.addEventListener('DOMContentLoaded', () => { this.updatePrice(this.currentVariant.id); this.updateSoldOutBadge(); });
        window.addEventListener('load', () => { this.updatePrice(this.currentVariant.id); this.updateSoldOutBadge(); });


        window.addEventListener('DOMContentLoaded', () => this.updatePrice(this.currentVariant.id));
        window.addEventListener('load', () => this.updatePrice(this.currentVariant.id));

        document.addEventListener('shopify:section:load', () => this.updatePrice(this.currentVariant.id));
        document.addEventListener('shopify:section:select', () => this.updatePrice(this.currentVariant.id));
        document.addEventListener('shopify:block:select', () => this.updatePrice(this.currentVariant.id));
    }

    disconnectedCallback() {
        this.removeEventListener('submit', this.handleFormSubmit.bind(this));
        this.removeEventListener('change', this.updateVariant.bind(this));
    }

    updateVariant() {
        let selectedOptions = [];
        this.querySelectorAll('[name^="option-"]:checked').forEach(input => {
            selectedOptions.push(input.value);
            const wrapper = input.closest('.variant-option');
            if (wrapper) wrapper.querySelector('.selected-value').innerText = input.value;
        });

        this.currentVariant = this.variants.find(v => JSON.stringify(v.options) === JSON.stringify(selectedOptions));
        if (!this.currentVariant) return;

        this.querySelector('.selected-variant-id').value = this.currentVariant.id;
        window.history.replaceState({}, '', `?variant=${this.currentVariant.id}`);

        /* ------------------------------------
        VARIANT → MEDIA CHANGE (ALL LAYOUTS)
        -------------------------------------*/

        const variantMedia = this.currentVariant?.featured_media;
        if (variantMedia) {
            const mediaId = variantMedia.id;

            // Detect layout
            const layout = document.querySelector('.product-page-container')?.dataset.layout;

            // Find ALL media (image/video/model)
            const allMedia = Array.from(
                document.querySelectorAll('.product-gallery [data-image-id], .product-gallery [data-media-id]')
            );

            // Create normalised dataset key
            const targetIndex = allMedia.findIndex(item => {
                return (
                    item.dataset.imageId == mediaId ||
                    item.dataset.mediaId == mediaId
                );
            });

            /* ------------------------------------
            CASE 1: SLIDER MODE (thumbnail_carousel + mobile)
            -------------------------------------*/
            if (layout === "thumbnail_carousel" || window.innerWidth < 750) {
                if (window.mainSlider && targetIndex >= 0) {
                    window.mainSlider.slideTo(targetIndex);
                }
            }

            /* ------------------------------------
            CASE 2: STACKED / COLUMNS MODE
            → Move active media to FIRST
            -------------------------------------*/
            if (layout === "stacked" || layout === "columns") {
                const gallery = document.querySelector('.thumbnails');
                if (gallery && targetIndex >= 0) {
                    const targetNode = allMedia[targetIndex].closest('.thumbnail');
                    if (targetNode) {
                        gallery.prepend(targetNode);
                    }
                }
            }

            /* ------------------------------------
            UPDATE ACTIVE CLASS (thumbnails)
            -------------------------------------*/
            document.querySelectorAll('.thumbnail-image').forEach(img =>
                img.classList.remove('active')
            );

            const activeThumb =
                document.querySelector(`.thumbnail-image[data-image-id="${mediaId}"]`) ||
                document.querySelector(`.thumbnail-image[data-media-id="${mediaId}"]`);

            if (activeThumb) activeThumb.classList.add('active');
        }

        this.updatePrice(this.currentVariant.id);
        this.updateSoldOutBadge();

        const addToCartBtn = this.querySelector('button[type="submit"]');
        const buyNowBtn = this.querySelector('.buy-now');
        const buyNowWrapper = this.querySelector('.buy-now-wrapper, .buy_payment');

        if (!this.currentVariant.available) {

            // ADD TO CART
            addToCartBtn.setAttribute('disabled', true);
            addToCartBtn.classList.add('sold-out-message');
            addToCartBtn.classList.remove('add-to-cart-btn');
            addToCartBtn.innerText = 'SOLD OUT';
            // ✅ Ensure Add to Cart button is visible even when sold out
            if (addToCartBtn.style.display === 'none') {
                addToCartBtn.style.display = '';
            }

            // BUY NOW
            if (buyNowBtn) {
                buyNowBtn.setAttribute('disabled', true);
                buyNowBtn.classList.add('disabled');
                buyNowBtn.style.display = 'none';
            }


        } else {

            // ADD TO CART
            addToCartBtn.removeAttribute('disabled');
            addToCartBtn.classList.remove('sold-out-message');
            addToCartBtn.classList.add('add-to-cart-btn');
            addToCartBtn.innerText = 'Add to Cart';
            // ✅ Ensure Add to Cart button is visible (override Shopify payment_button hiding)
            if (addToCartBtn.style.display === 'none') {
                addToCartBtn.style.display = '';
            }
            // Also ensure it's not hidden by inline styles
            const computedStyle = window.getComputedStyle(addToCartBtn);
            if (computedStyle.display === 'none' && buyNowWrapper) {
                addToCartBtn.style.display = 'block';
            }

            // BUY NOW
            if (buyNowBtn) {
                buyNowBtn.removeAttribute('disabled');
                buyNowBtn.classList.remove('disabled');
                buyNowBtn.style.display = 'inline-block';
            }


        }
    }

    async handleFormSubmit(evt) {
        evt.preventDefault();

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        let requestedQty = parseInt(formData.get('quantity')) || 1;

        const variant = this.variants.find(v => v.id == variantId);
        if (!variant) return;

        const inventoryQty = variant.inventory_quantity ?? 0;

        // 🔒 FINAL HARD RULE
        const effectiveMax = inventoryQty > 45 ? 45 : inventoryQty;

        try {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();

            let alreadyInCart = 0;
            cart.items.forEach(item => {
            if (item.variant_id == variantId) {
                alreadyInCart = item.quantity;
            }
            });

            const box = this.querySelector('.cart-qty-message');
            const text = box?.querySelector('.text');

            /* ----------------------------------
            CASE 1: Already max in cart
            ---------------------------------- */
            if (alreadyInCart >= effectiveMax) {
            if (box && text) {
                text.innerText = 'The maximum quantity of this item is already in your cart.';
                box.style.display = 'flex';
                clearTimeout(box.hideTimer);
                box.hideTimer = setTimeout(() => (box.style.display = 'none'), 3000);
            }
            return; // ⛔ STOP
            }

            /* ----------------------------------
            CASE 2: Requested > allowed
            → ADD ONLY remaining (45 or inventory)
            ---------------------------------- */
            if (alreadyInCart + requestedQty > effectiveMax) {
            const allowedQty = effectiveMax - alreadyInCart;

            formData.set('quantity', allowedQty); // 🔥 FORCE QTY

            if (box && text) {
                text.innerText =
                effectiveMax === 45
                    ? 'Only 45 items were added to your cart due to availability.'
                    : `Only ${effectiveMax} items were added to your cart due to availability.`;

                box.style.display = 'flex';
                clearTimeout(box.hideTimer);
                box.hideTimer = setTimeout(() => (box.style.display = 'none'), 3000);
            }
            }

        } catch (e) {
            console.error('Cart check failed', e);
            return;
        }

        /* ----------------------------------
            ✅ ADD TO CART (SAFE)
        ---------------------------------- */
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(json => {
            if (json.status != 'bad_request') {
                document.querySelector('side-cart')?.addLineItem(json);

                if (typeof showCartNotification === 'function') {
                showCartNotification(json);
                }

                document.body.dispatchEvent(new Event('ajax:updateCart'));
            } else {
                alert('Error: ' + json.message);
            }
            })
            .catch(err => console.error('Add to cart error:', err));
        }

}

customElements.define('product-form', ProductForm);